import * as types from '../ActionTypes/LeaderboardsActionTypes';
import { getLeaderboardModelsArray } from './helpers';

const initialState = {
    statuses: {
        areLeaderboardsForSliderLoading: false,
        isLeaderboardsListLoading: false,
        isLeaderboardUpdating: false,
    },
    moreLeaderboardsToLoad: true,
    leaderboardsList: [],
    leaderboardsSlider: {},
};

export function LeaderboardsReducer(state = initialState, { type, payload, meta, ...action }) {
    switch (type) {
        // get profile or workout leaderboards list
        case types.GET_PROFILE_LEADERBOARDS_REQUEST:
        case types.GET_WORKOUT_LEADERBOARDS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isLeaderboardsListLoading: true,
                },
            };
        }
        case types.GET_PROFILE_LEADERBOARDS_SUCCESS:
        case types.GET_WORKOUT_LEADERBOARDS_SUCCESS: {
            const leaderboardsArray = getLeaderboardModelsArray(payload.data);

            return {
                ...state,
                leaderboardsList: [...leaderboardsArray],
                statuses: {
                    ...state.statuses,
                    isLeaderboardsListLoading: false,
                },
            };
        }

        case types.GET_PROFILE_LEADERBOARDS_FAILED:
        case types.GET_WORKOUT_LEADERBOARDS_FAILED: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isLeaderboardsListLoading: false,
                },
            };
        }

        // load more workout or profile leaderboards
        case types.LOAD_MORE_PROFILE_LEADERBOARDS_REQUEST:
        case types.LOAD_MORE_WORKOUT_LEADERBOARDS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                },
            };
        }

        case types.LOAD_MORE_PROFILE_LEADERBOARDS_SUCCESS:
        case types.LOAD_MORE_WORKOUT_LEADERBOARDS_SUCCESS: {
            const moreLeaderboardsToLoad = payload.data.length > 0;
            const leaderboardsArray = getLeaderboardModelsArray(payload.data);

            return {
                ...state,
                leaderboardsList: [...state.leaderboardsList, ...leaderboardsArray],
                moreLeaderboardsToLoad,
                statuses: {
                    ...state.statuses,
                },
            };
        }

        case types.RESET_LEADERBOARDS_SCROLL: {
            return {
                ...state,
                moreLeaderboardsToLoad: true,
            };
        }

        case types.GET_LEADERBOARDS_FOR_SLIDER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    areLeaderboardsForSliderLoading: true,
                },
            };
        }

        case types.GET_LEADERBOARDS_FOR_SLIDER_SUCCESS: {
            const leaderboardsObject = {};
            const leaderboardsArray = getLeaderboardModelsArray(payload);

            leaderboardsArray.forEach(leaderboard => {
                leaderboardsObject[`leaderboard${leaderboard.id}`] = { ...leaderboard };
            });

            return {
                ...state,
                leaderboardsSlider: { ...state.leaderboardsSlider, ...leaderboardsObject },
                statuses: {
                    ...state.statuses,
                    areLeaderboardsForSliderLoading: false,
                },
            };
        }

        case types.UPDATE_LEADERBOARD_USERS_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isLeaderboardUpdating: true,
                },
            };
        }

        case types.UPDATE_LEADERBOARD_USERS_SUCCESS: {
            let newSlides = state.leaderboardsSlider;

            newSlides.forEach(leaderboard => {
                if (leaderboard.id === payload.id) {
                    leaderboard.users = payload.users;
                }
            });

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isLeaderboardUpdating: false,
                },
                leaderboardsSlider: newSlides,
            };
        }

        case 'KILL_CARUSEL': {
            return initialState;
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/LeaderboardsReducer.js